
import React from 'react';
import { 
  Sheet, 
  SheetContent, 
  SheetHeader, 
  SheetTitle, 
  SheetDescription,
  SheetTabs,
  SheetTabsList,
  SheetTabsTrigger,
  SheetTabsContent
} from "@/components/ui/sheet";
import { ALMContract } from './types';
import ContractDetailsOverview from './ContractDetailsOverview';
import ContractSchedules from './ContractSchedules';
import ContractResets from './ContractResets';

interface ContractDetailsSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contract: ALMContract | null;
}

const ContractDetailSheet: React.FC<ContractDetailsSheetProps> = ({
  open,
  onOpenChange,
  contract
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="sm:max-w-md md:max-w-lg lg:max-w-xl overflow-y-auto">
        {contract && (
          <>
            <SheetHeader>
              <SheetTitle>{contract.name}</SheetTitle>
              <SheetDescription>
                <div className="flex items-center gap-2 mt-1">
                  <span className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${getTypeStyle(contract.type)}`}>
                    {contract.type}
                  </span>
                  <span className="text-muted-foreground">{contract.reference}</span>
                </div>
              </SheetDescription>
            </SheetHeader>
            
            <div className="mt-6">
              <SheetTabs defaultValue="overview">
                <SheetTabsList className="grid grid-cols-3">
                  <SheetTabsTrigger value="overview">Overview</SheetTabsTrigger>
                  <SheetTabsTrigger value="schedules">Schedules</SheetTabsTrigger>
                  <SheetTabsTrigger value="assumptions">Resets & Assumptions</SheetTabsTrigger>
                </SheetTabsList>
                <div className="mt-4">
                  <SheetTabsContent value="overview">
                    <ContractDetailsOverview contract={contract} />
                  </SheetTabsContent>
                  <SheetTabsContent value="schedules">
                    <ContractSchedules contract={contract} />
                  </SheetTabsContent>
                  <SheetTabsContent value="assumptions">
                    <ContractResets contract={contract} />
                  </SheetTabsContent>
                </div>
              </SheetTabs>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

const getTypeStyle = (type: string) => {
  switch (type) {
    case 'Loan Asset':
      return 'bg-green-100 text-green-800';
    case 'Fixed Deposit':
      return 'bg-blue-100 text-blue-800';
    case 'NCD':
      return 'bg-purple-100 text-purple-800';
    case 'Term Loan':
      return 'bg-red-100 text-red-800';
    case 'Working Capital':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export default ContractDetailSheet;
